import React from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { TaskDetailPage } from '../../pages/tasks/TaskDetailPage';

export const Route = createFileRoute('/tasks/$taskId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { taskId } = useParams({ from: '/tasks/$taskId' });
  return <TaskDetailPage taskId={taskId} />;
}
